import { Box, Typography, styled } from '@mui/material';
import { NavLink } from 'components';

export const LibraryTracksContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: theme.spacing(1, 2),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3, 3, 0, 5),
  },
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
}));

export const LibraryTracksHeader = styled(Typography)({
  fontSize: 32,
  fontStyle: 'normal',
  fontWeight: 500,
});

export const LibraryTrackNavbar = styled(Box)(({ theme }) => ({
  display: 'flex',
  boxShadow: `inset 0px -1px 0px 0px ${theme.palette.grey[700]}`,
}));

export const StyledNavLink = styled(NavLink)(({ theme }) => ({
  fontSize: 14,
  fontStyle: 'normal',
  fontWeight: 500,
  letterSpacing: '0.4px',
  textTransform: 'uppercase',
  padding: theme.spacing(2, 1),
  '&.active': {
    borderBottom: '1px solid',
    borderBottomColor: 'inherit',
  },
}));
